import styled from '@emotion/styled';
import { useIsMobile } from '@stores/AppCommonData';
import Typography from 'aquilla/core/atoms/Typography';
import Accordion from 'aquilla/core/molecules/Accordion';
import { mediaQuery, Spacings } from '@styles/index';
import React, { useState, useEffect } from 'react';
import { fetchSubscriptionFaqs } from '@api/fetchers/checkout';

const Container = styled.section`
  grid-column: 1 / -1;
  width: 100%;
  margin: 24px auto 0;
  padding: 0 16px 64px;
  box-sizing: border-box;
  margin-bottom: ${Spacings.SPACING_12B};

  ${mediaQuery.uptoMobile} {
    padding: 0 12px 48px;
  }
`;

const Title = styled(Typography)`
  color: var(--color-i-white);
  margin-bottom: 24px;
`;

const FAQsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const StyledAccordion = styled(Accordion)`
  border-radius: 12px;
  border: 1px solid var(--color-i-prime-card);
  background: var(--color-i-prime-card);

  &:hover {
    background: var(--color-i-prime-card);
  }

  & .aquilla-accordion-header svg {
    color: var(--color-i-white-72);
  }
`;

const Question = styled(Typography)`
  color: var(--color-i-white);
`;

const Answer = styled.div`
  color: var(--color-i-white-72);
  font-family: 'Averta Std', sans-serif;
  font-size: 14px;
  line-height: 22px;
`;

const FAQSection = () => {
  const isMobile = useIsMobile();
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    let isMounted = true;

    fetchSubscriptionFaqs('primesubscription')
      .then((response) => {
        if (!isMounted) return;
        setFaqs(response?.faqs || []);
      })
      .catch(() => {
        if (!isMounted) return;
        setFaqs([]);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!faqs.length) return null;

  return (
    <Container>
      <Title variant={isMobile ? 'h5' : 'h4'}>FREQUENTLY ASKED QUESTIONS</Title>

      <FAQsWrapper>
        {faqs.map(({ id, question, answer }) => (
          <StyledAccordion
            key={id}
            title={
              <Question variant={isMobile ? 'h6' : 'h5'}>{question}</Question>
            }
          >
            <Answer>{answer}</Answer>
          </StyledAccordion>
        ))}
      </FAQsWrapper>
    </Container>
  );
};

export default React.memo(FAQSection);
